import React from 'react';
import Style from './dropdown.module.css';
/** @jsxImportSource @emotion/react */

import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";

const Dropdown = props => {
  const propsArray = [];
  propsArray.className = props.className === undefined ? '' : props.className;
  let emotionStyle = [];

  if (props.ms !== undefined) {
    emotionStyle = props.ms;
  }

  document.addEventListener('click', event => {
    let dropdownBody = document.querySelectorAll(`.${Style.dropdown} .${Style.body}`);

    if (event.target.closest(`.${Style.dropdown}`) === null) {
      for (let i = 0; i < dropdownBody.length; i++) {
        dropdownBody[i].classList.remove('d-block');
        dropdownBody[i].classList.add('d-none');
      }
    }
  });
  return _jsxs(React.Fragment, {
    children: [propsArray.className === '' && _jsx("div", {
      className: `${Style.dropdown}`,
      css: emotionStyle,
      children: props.children
    }), propsArray.className !== '' && _jsx("div", {
      className: `${Style.dropdown} ${propsArray.className}`,
      css: emotionStyle,
      children: props.children
    })]
  });
};

Dropdown.Toggle = props => {
  const propsArray = [];
  propsArray.className = props.className === undefined ? '' : props.className;
  let emotionStyle = [];

  if (props.ms !== undefined) {
    emotionStyle = props.ms;
  }

  const dropdownToggle = event => {
    if (event.target.closest(`.${Style.dropdown}`).querySelector(`.${Style.body}`).classList.contains('d-none')) {
      event.target.closest(`.${Style.dropdown}`).querySelector(`.${Style.body}`).classList.remove('d-none');
      event.target.closest(`.${Style.dropdown}`).querySelector(`.${Style.body}`).classList.add('d-block');
      event.target.closest(`.${Style.dropdown}`).querySelector(`.${Style.body}`).classList.add(Style.slideDown);
    } else {
      event.target.closest(`.${Style.dropdown}`).querySelector(`.${Style.body}`).classList.remove('d-block');
      event.target.closest(`.${Style.dropdown}`).querySelector(`.${Style.body}`).classList.remove(Style.slideDown);
      event.target.closest(`.${Style.dropdown}`).querySelector(`.${Style.body}`).classList.add('d-none');
    }
  };

  return _jsxs(React.Fragment, {
    children: [propsArray.className === '' && _jsx("div", {
      onClick: dropdownToggle,
      css: emotionStyle,
      children: props.children
    }), propsArray.className !== '' && _jsx("div", {
      onClick: dropdownToggle,
      className: `${propsArray.className}`,
      css: emotionStyle,
      children: props.children
    })]
  });
};

Dropdown.Body = props => {
  const propsArray = [];
  propsArray.className = props.className === undefined ? '' : props.className;
  propsArray.position = Style[props.position === undefined ? 'bottomLeft' : props.position];
  let emotionStyle = [];

  if (props.ms !== undefined) {
    emotionStyle = props.ms;
  }

  return _jsxs(React.Fragment, {
    children: [propsArray.className === '' && _jsxs("div", {
      className: `d-none ${Style.body} ${propsArray.position}`,
      css: emotionStyle,
      children: [_jsx("div", {
        className: Style.triangleUp,
        children: _jsx("div", {})
      }), props.children]
    }), propsArray.className !== '' && _jsxs("div", {
      className: `d-none ${Style.body} ${propsArray.position} ${propsArray.className}`,
      css: emotionStyle,
      children: [_jsx("div", {
        className: Style.triangleUp,
        children: _jsx("div", {})
      }), props.children]
    })]
  });
};

export default Dropdown;